export const letters_matrices = {
    5: {
        A: [[0,0,1,0,0],
            [0,1,0,1,0],
            [1,1,1,1,1],
            [1,0,0,0,1],
            [1,0,0,0,1],
        ],
        B: [[1,1,1,1,0],
            [1,0,0,0,1],
            [1,1,1,1,0],
            [1,0,0,0,1],
            [1,1,1,1,0],
        ],
        C: [[0,0,1,1,1],
            [0,1,0,0,0],
            [1,0,0,0,0],
            [0,1,0,0,0],
            [0,0,1,1,1],
        ],
        E: [[1,1,1,1,1],
            [1,0,0,0,0],
            [1,1,1,1,1],
            [1,0,0,0,0],
            [1,1,1,1,1],
        ],
        H: [[1,0,0,0,1],
            [1,0,0,0,1],
            [1,1,1,1,1],
            [1,0,0,0,1],
            [1,0,0,0,1],
        ],
        I: [[1,1,1,1,1],
            [0,0,1,0,0],
            [0,0,1,0,0],
            [0,0,1,0,0],
            [1,1,1,1,1],
        ],
        L: [[1,0,0,0,0],
            [1,0,0,0,0],
            [1,0,0,0,0],
            [1,0,0,0,0],
            [1,1,1,1,1],
        ],
        M: [[1,0,0,0,1],
            [1,1,0,1,1],
            [1,0,1,0,1],
            [1,0,0,0,1],
            [1,0,0,0,1],
        ],
        O: [[0,0,1,0,0],
            [0,1,0,1,0],
            [1,0,0,0,1],
            [0,1,0,1,0],
            [0,0,1,0,0],
        ],
        W: [[1,0,0,0,1],
            [1,0,0,0,1],
            [1,0,1,0,1],
            [1,1,0,1,1],
            [1,0,0,0,1],
        ],
        " ": [[0,0,0,0,0],
            [0,0,0,0,0],
            [0,0,0,0,0],
            [0,0,0,0,0],
            [0,0,0,0,0],
        ],
        "_": [[0,0,0,0,0],
            [0,0,0,0,0],
            [0,0,0,0,0],
            [0,0,0,0,0],
            [1,1,1,1,1],
        ],
        "*": [[1,0,1,0,1],
            [0,1,1,1,0],
            [1,1,1,1,1],
            [0,1,1,1,0],
            [1,0,1,0,1],
        ],
    }, 

    7: {
    A:  [[0,0,0,1,0,0,0],
         [0,0,1,0,1,0,0],
         [0,1,0,0,0,1,0],
         [1,1,1,1,1,1,1],
         [1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
        ],
    C:  [[0,0,0,1,1,1,1],
         [0,0,1,0,0,0,0],
         [0,1,0,0,0,0,0],
         [1,0,0,0,0,0,0],
         [0,1,0,0,0,0,0],
         [0,0,1,0,0,0,0],
         [0,0,0,1,1,1,1],
        ],
    E:  [[1,1,1,1,1,1,1],
         [1,0,0,0,0,0,0],
         [1,0,0,0,0,0,0],
         [1,1,1,1,1,1,1],
         [1,0,0,0,0,0,0],
         [1,0,0,0,0,0,0],
         [1,1,1,1,1,1,1],
        ],
    H:  [[1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
         [1,1,1,1,1,1,1],
         [1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
        ],
    I:  [[1,1,1,1,1,1,1],
         [0,0,0,1,0,0,0],
         [0,0,0,1,0,0,0],
         [0,0,0,1,0,0,0],
         [0,0,0,1,0,0,0],
         [0,0,0,1,0,0,0],
         [1,1,1,1,1,1,1],
        ],
    L:  [[1,0,0,0,0,0,0],
         [1,0,0,0,0,0,0],
         [1,0,0,0,0,0,0],
         [1,0,0,0,0,0,0],
         [1,0,0,0,0,0,0],
         [1,0,0,0,0,0,0],
         [1,1,1,1,1,1,1],
        ],
    M:  [[1,0,0,0,0,0,1],
         [1,1,0,0,0,1,1],
         [1,0,1,0,1,0,1],
         [1,0,0,1,0,0,1],
         [1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
        ],
    N:  [[1,0,0,0,0,0,1],
         [1,1,0,0,0,0,1],
         [1,0,1,0,0,0,1],
         [1,0,0,1,0,0,1],
         [1,0,0,0,1,0,1],
         [1,0,0,0,0,1,1],
         [1,0,0,0,0,0,1],
        ],
    O:  [[0,1,1,1,1,1,0],
         [1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
         [0,1,1,1,1,1,0],
        ],
    R:  [[1,1,1,1,1,0,0],
         [1,0,0,0,0,1,0],
         [1,0,0,0,0,0,1],
         [1,1,1,1,1,1,0],
         [1,0,0,0,1,0,0],
         [1,0,0,0,0,1,0],
         [1,0,0,0,0,0,1],
        ],
    T:  [[1,1,1,1,1,1,1],
         [0,0,0,1,0,0,0],
         [0,0,0,1,0,0,0],
         [0,0,0,1,0,0,0],
         [0,0,0,1,0,0,0],
         [0,0,0,1,0,0,0],
         [0,0,0,1,0,0,0],
        ],
    W:  [[1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
         [1,0,0,0,0,0,1],
         [1,0,0,1,0,0,1],
         [1,0,1,0,1,0,1],
         [1,1,0,0,0,1,1],
         [1,0,0,0,0,0,1],
       ],
    X:  [[1,0,0,0,0,0,1],
         [0,1,0,0,0,1,0],
         [0,0,1,0,1,0,0],
         [0,0,0,1,0,0,0],
         [0,0,1,0,1,0,0],
         [0,1,0,0,0,1,0],
         [1,0,0,0,0,0,1],
        ],
    "*":  [[1,0,0,1,0,0,1],
           [0,1,0,1,0,1,0],
           [0,0,1,1,1,0,0],
           [1,1,1,1,1,1,1],
           [0,0,1,1,1,0,0],
           [0,1,0,1,0,1,0],
           [1,0,0,1,0,0,1],
        ],
    "_": [[0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
          [1,1,1,1,1,1,1],
         ],
    "!": [[0,0,0,1,0,0,0],
          [0,0,0,1,0,0,0],
          [0,0,0,1,0,0,0],
          [0,0,0,1,0,0,0],
          [0,0,0,1,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,0,1,0,0,0],
         ],
    ":": [[0,0,1,1,0,0,0],
          [0,0,1,1,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,1,1,0,0,0],
          [0,0,1,1,0,0,0],
         ],
    ")": [[0,0,1,1,0,0,0],
          [0,0,0,0,1,0,0],
          [0,0,0,0,0,1,0],
          [0,0,0,0,0,0,1],
          [0,0,0,0,0,1,0],
          [0,0,0,0,1,0,0],
          [0,0,1,1,0,0,0],
         ],
    " ": [[0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
          [0,0,0,0,0,0,0],
         ],
    }
}